import { createRoot, hydrateRoot } from "react-dom/client";
import App, { findRoute, resolvePage } from "./App.jsx";
import "./styles/site.css";

const pathname = window.location.pathname;
const route = findRoute(pathname);
if (route) {
  document.documentElement.lang = route.lang;
  document.title = route.title;
}
try {
  document.documentElement.dataset.theme =
    localStorage.getItem("novavp-theme") === "light" ? "light" : "dark";
} catch {
  document.documentElement.dataset.theme = "dark";
}
async function start() {
  const Page = await resolvePage(pathname);
  const root = document.getElementById("app");
  if (root.dataset.prerendered === "true")
    hydrateRoot(root, <App Page={Page} />);
  else createRoot(root).render(<App Page={Page} />);
}
start().catch((error) => {
  console.error("NovaVP could not initialize", error);
});
